class DrawerRecommendation extends HTMLElement {
  constructor() {
    super();
    if (sessionStorage.getItem('block_drawer_recommendation')) return
    this.checkCart()
  }

  async checkCart() {
    const cartContent = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    const existInCart = cartContent.items.find(t => t.variant_id == this.dataset.id)
    if (existInCart == undefined) this.showRecommendation()
  }

  showRecommendation() {
    this.classList.remove('hidden-recommendation')
  }

  hideRecommendation() {
    this.classList.add('hidden-recommendation')
    sessionStorage.setItem('block_drawer_recommendation', true)
  }

  connectedCallback() {
    this.addEventListener('click', (e) => {
      if(e.target.classList.contains("recommendation-disallow")) this.hideRecommendation()
    })
  }
}

if (!customElements.get('drawer-recommendation')) customElements.define('drawer-recommendation', DrawerRecommendation);